module.exports = "/_next/static/images/solarEnergy-39c73d2d94b59470b50084b6bdc9db0f.png";